import React, { useState } from 'react'
import { ImageOff } from 'lucide-react'

// Insert Cloudinary transforms so we serve a scaled-down, auto-format/quality
// image instead of the full-size original. Non-Cloudinary URLs pass through.
const optimize = (url, width) => {
    if (typeof url === 'string' && url.includes('/upload/')) {
        return url.replace('/upload/', `/upload/f_auto,q_auto,c_limit,w_${width}/`)
    }
    return url
}

/**
 * Drop-in <img> replacement for product/shop imagery.
 * - Requests a scaled-down version (Cloudinary) for faster loads.
 * - Lazy-loads + async-decodes off-screen images.
 * - On a missing/broken source, renders an image icon instead of a broken img.
 * Pass the same sizing className you'd give the <img> so the fallback matches.
 */
const SmartImage = ({ src, alt = '', width = 400, className = '', iconSize = 36, ...rest }) => {
    const [errored, setErrored] = useState(false)

    if (!src || errored) {
        return (
            <div className={`flex items-center justify-center bg-[#1C1C1C] text-white/25 ${className}`}>
                <ImageOff size={iconSize} strokeWidth={1.5} />
            </div>
        )
    }

    return (
        <img
            src={optimize(src, width)}
            alt={alt}
            loading='lazy'
            decoding='async'
            onError={() => setErrored(true)}
            className={className}
            {...rest}
        />
    )
}

export default SmartImage
